import React from 'react';

import cx from 'classnames';

import s from './Circle.module.scss';

type CircleProps = {
  className?: string;
  size?: string;
  children?: React.ReactNode;
};

const Circle: React.FC<CircleProps> = ({
  size,
  children,
  className,
  ...props
}) => {
  return (
    <div
      className={cx(
        s.circle,
        s[`circle-${size}`],
        'overflow-hidden',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export default Circle;
